export const DiscoverConstants = {
  AuthorizationServiceCodes: [
    {
      value: 201,
      description:
        "201: Chip card valid for international unrestricted interchange"
    },
    {
      value: 209,
      description:
        "209: Contactless magnetic stripe payment device valid for international unrestricted interchange"
    },
    {
      value: 601,
      description: "601: Chip card valid only within the country of issuance"
    }
  ],
  CancellationMethods: [
    {
      value: "PERSON",
      description: "Transaction was cancelled through a person."
    },
    {
      value: "PHONE",
      description: "Transaction was cancelled via phone."
    },
    {
      value: "MAIL",
      description: "Transaction was cancelled via mail."
    },
    {
      value: "INTERNET",
      description: "Transaction was cancelled via internet."
    }
  ],
  CancelledOrReturned: [
    { value: "C", description: "Cancelled" },
    { value: "R", description: "Returned" }
  ],
  CountryCodes: [{ value: "NG", description: "Nigeria" }],
  CaseInFavorOf: [
    { value: "M", description: "Merchant" },
    { value: "C", description: "Cardholder" },
    { value: "N", description: "Await network decision" }
  ],
  CaseStatuses: [
    { value: "CO", description: "Case Open" },
    { value: "CC", description: "Case Closed" }
  ],
  CashOverOptions: [
    { value: "Mrch", description: "Merchandise" },
    { value: "Cash", description: "Cash" },
    { value: "Both", description: "Merchandise and Cash" },
    { value: "None", description: "Transaction did not contain cash" }
  ],
  CaseRequestStatus: {
    Pending: "Pending",
    Declined: "Declined",
    Failed: "Failed",
    Successful: "Successful"
  },
  CaseRequestStatusList: [
    {
      value: "Pending",
      description: "Pending"
    },
    {
      value: "Declined",
      description: "Declined"
    },
    {
      value: "Failed",
      description: "Failed"
    },
    {
      value: "Successful",
      description: "Successful"
    }
  ],
  CaseRequestTypes: {
    caseUpdate: "Update Case",
    caseCreation: "Create Case"
  },
  CaseRequestTypeList: [
    { value: "Create Case", description: "Create Case" },
    { value: "Update Case", description: "Update Case" }
  ],
  caseUpdatePermissions: {
    addCaseNote: "Add_Case_Note",
    addCaseDocument: "Add_Case_Document",
    viewCaseDetails: "View_Case_Details",
    viewCaseDocuments: "View_Case_Documents",
    viewCaseHistory: "View_Case_History",
    viewCaseNotes: "View_Case_Notes",
    updateCase: "Update_Case"
  },
  Currencies: [
    { value: "NGN", description: "Nigerian Naira" },
    { value: "USD", description: "US Dollars" }
  ],
  ConditionsForAmounts: [
    {
      value: "equals",
      description: "Is equal to"
    },
    {
      value: "lessThan",
      description: "Is less than"
    },
    {
      value: "greaterThan",
      description: "Is greater than"
    }
  ],
  CaseCreationStatuses:{
    case_created: "case_created",
    case_request_submitted: "case_request_submitted"
  },
  DocTypes: [
    { value: "01", description: "Sales Slip" },
    { value: "02", description: "Credit Slip" },
    { value: "03", description: "Proof of delivery or return" },
    { value: "04", description: "Cancellation Verification" },
    { value: "05", description: "Cancellation Number" },
    { value: "06", description: "Airline Ticket" },
    { value: "07", description: "Merchant Contract or Agreement" },
    { value: "08", description: "Assignment Letter" },
    { value: "99", description: "Other Documentation" }
  ],
  DocumentationIndicators: [
    { value: "0", description: "Supporting document will not be provided" },
    { value: "1", description: "Supporting document will be provided" },
    {
      value: "2",
      description:
        "No supporting documentation was received for prior Representment"
    },
    { value: "4", description: "Issuer certification of dispute" }
  ],
  DocumentOwners: [
    {
      value: "ACQUIRER",
      description: "Acquirer was the source of this document image"
    },
    {
      value: "ISSUER",
      description: "Issuer was the source of the document image"
    }
  ],
  DuplicateSearchOptions: [
    { value: "DP", description: "Duplicate Processing" },
    { value: "RB", description: "Recurring Payments" }
  ],
  FileFormats: [
    { value: "PDF", description: "Portable Document Format" },
    { value: "TIF", description: "Tagged Image File Format (TIF)" },
    { value: "TIFF", description: "Tagged Image File Format (TIFF)" }
  ],
  NoticeTypeCodes: [
    { value: "T", description: "Ticket Retrieval Request" },
    { value: "C", description: "Chargeback" },
    { value: "R", description: "Representment" },
    { value: "P", description: "Pre-Arbitration" },
    { value: "A", description: "Arbitration" },
    { value: "U", description: "Pre-Arbitration Withdrawal" },
    { value: "X", description: "Pre-Arbitration Decision" },
    { value: "M", description: "Arbitration Additional Documentation Request" },
    { value: "V", description: "Issuer Arbitration Withdrawal" }
  ],
  ResponseCodeLevels: [
    { value: "I", description: "Informational" },
    { value: "W", description: "Warning" },
    { value: "E", description: "Error" },
    { value: "F", description: "Fatal" }
  ],
  ReturnMethods: [
    { value: "PERSON", description: "Transaction was returned in person." },
    { value: "MAIL", description: "Transaction was returned via the mail." },
    { value: "CARRIER", description: "Transaction was returned via a carrier." }
  ],
  ReasonCodesThatRequireMotiveCodes: [
    "03",
    "04",
    "AT",
    "RM",
    "TF",
    "UA01",
    "UA02",
    "DC"
  ],
  CurrencyCodes: {
    "566": "NGN"
  }
};



// WEBPACK FOOTER //
// ./src/configurations/discoverConfigs/discoverConstants.js